<template>
  <nav class="navbar-container">
    <!-- Desktop Navigation -->
    <div class="desktop-nav" v-if="!isMobile">
      <div class="brand">
        <router-link to="/" class="brand-link">
          <i class="fas fa-book-open fa-lg"></i>
          <span class="brand-name">iChrispin Diary</span>
        </router-link>
      </div>
      <div class="nav-links">
        <router-link 
          v-for="(item, index) in navItems" 
          :key="index" 
          :to="item.path" 
          class="nav-item"
        >
          <i :class="item.icon"></i>
          {{ item.name }}
        </router-link>
      </div>
    </div>

    <!-- Mobile Navigation -->
    <div class="mobile-nav" v-else>
      <div class="mobile-header">
        <router-link to="/" class="brand-link">
          <i class="fas fa-book-open fa-lg"></i>
          <span class="brand-name">iChrispin Diary</span>
        </router-link>
        <button 
          class="hamburger" 
          :class="{ 'active': isMenuOpen }" 
          @click="toggleMenu"
        >
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </button>
      </div>

      <!-- Mobile Menu Overlay -->
      <transition name="slide">
        <div v-if="isMenuOpen" class="mobile-menu-overlay" @click="closeMenu">
          <div class="mobile-menu" @click.stop>
            <router-link
              v-for="(item, index) in navItems"
              :key="index"
              :to="item.path"
              class="mobile-nav-item"
              @click="closeMenu"
            >
              <i :class="item.icon"></i>
              {{ item.name }}
            </router-link>
          </div>
        </div>
      </transition>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'ResponsiveNavbar',
  data() {
    return {
      isMenuOpen: false,
      isMobile: false,
      navItems: [
        { name: 'Love Life', path: '/love-life', icon: 'fas fa-heart' },
        { name: 'Family', path: '/family', icon: 'fas fa-users' },
        { name: 'Jokes', path: '/jokes', icon: 'fas fa-laugh' },
        { name: 'Stories', path: '/stories', icon: 'fas fa-book' },
        { name: 'Food for Thought', path: '/food-for-thought', icon: 'fas fa-brain' },
        { name: 'Media', path: '/media', icon: 'fas fa-images' },
        { name: 'Poems', path: '/poems', icon: 'fas fa-paragraph' },
        { name: 'Joy', path: '/joy', icon: 'fas fa-grin' },
        { name: 'Relax', path: '/smk', icon: 'fas fa-smog' },
        { name: 'Math', path: '/math', icon: 'fas fa-calculator' },
        { name: 'Word', path: '/word', icon: 'fas fa-spell-check' }
      ]
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
    },
    checkMobile() {
      this.isMobile = window.matchMedia('(max-width: 1023px)').matches
    }
  },
  watch: {
    isMobile(newVal) {
      if (!newVal) this.closeMenu()
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile)
  }
}
</script>

<style scoped>
/* Shared Styles */
.navbar-container {
  background: linear-gradient(135deg, #2c3e50, #3498db);
  box-shadow: 0 2px 15px rgba(0,0,0,0.1);
}

.brand-link {
  display: flex;
  align-items: center;
  color: white;
  text-decoration: none;
  padding: 1rem;
}

.brand-name {
  margin-left: 0.8rem;
  font-size: 1.4rem;
  font-family: 'Pacifico', cursive;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
}

/* Desktop Styles */
.desktop-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.nav-links {
  display: flex;
  gap: 1.5rem;
}

.nav-item {
  color: white;
  text-decoration: none;
  padding: 1rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.nav-item:hover {
  background: rgba(255,255,255,0.15);
  transform: translateY(-2px);
}

/* Mobile Styles */
.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
}

.hamburger {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  z-index: 1000;
}

.bar {
  display: block;
  width: 25px;
  height: 3px;
  margin: 5px auto;
  background: white;
  transition: all 0.3s ease;
}

.hamburger.active .bar:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}

.hamburger.active .bar:nth-child(2) {
  opacity: 0;
}

.hamburger.active .bar:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}

.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);
  z-index: 999;
}

.mobile-menu {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 75%;
  max-width: 300px;
  background: linear-gradient(160deg, #2c3e50, #34495e);
  padding: 2rem 1rem;
  box-shadow: 4px 0 15px rgba(0,0,0,0.2);
}

.mobile-nav-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: white;
  text-decoration: none;
  padding: 1rem;
  margin: 0.5rem 0;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.mobile-nav-item:hover {
  background: rgba(255,255,255,0.1);
  transform: translateX(5px);
}

/* Transitions */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(-100%);
}

@media (min-width: 1024px) {
  .mobile-nav {
    display: none;
  }
}

@media (max-width: 1023px) {
  .desktop-nav {
    display: none;
  }
}
</style>
